module.exports = __webpack_public_path__ + "static/media/gmail.8a099e64.svg";